import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterState } from 'types';

export const initialState: FilterState = {
  year: 2021,
  month: 'august',
  role: 'Key',
  hqfilter: true,
  manager: '',
  manufactures: '',
  distributors: '',
  data: { reps: [] },
  isVisible: false,
  filter: {},
  isUpdated: false
};

const dashboardSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setYear: (state, { payload }: PayloadAction<any>) => {
      state.filter.year = payload;
    },
    setManager: (state, { payload }: PayloadAction<any>) => {
      state.filter.manager = payload;
    },
    setManufactures: (state, { payload }: PayloadAction<any>) => {
      state.filter.manufactures = payload;
    },
    setDistributers: (state, { payload }: PayloadAction<any>) => {
      state.filter.distributors = payload;
    },
    setMonth: (state, { payload }: PayloadAction<any>) => {
      state.filter.month = payload;
    },
    setReps: (state, { payload }: PayloadAction<any>) => {
      state.data.reps = payload;
    },
    setGlobalFilter: (state, { payload }: PayloadAction<any>) => {
      state.filter = payload;
    },
    toggleFilter: (state) => {
      console.log(`state.isVisible `, state.isVisible, !state.isVisible);
      state.isVisible = !state.isVisible;
    },
    updateFilter: (state, { payload }: PayloadAction<any>) => {
      console.log(`updateFilter payload`, payload);

      // if (payload) {
      //   for (const [key, value] of Object.entries(payload)) {
      //     if (value) {
      //       console.log(`--${key}: ${value}`);

      //       state.filter[key] = value;
      //     }
      //   }
      // }
      state.filter = { ...state.filter, ...payload };

      console.log(`updateFilter payload-------`, state.filter, state.isUpdated);
    },
    setUpdate: (state, { payload }: PayloadAction<any>) => {
      state.isUpdating = payload;
    }
  }
});

export const {
  setYear,
  setManager,
  setDistributers,
  setManufactures,
  setMonth,
  setReps,
  setGlobalFilter,
  toggleFilter,
  updateFilter,
  setUpdate
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
